import type { CalloutBlock } from '@atlas/renderer';
import { Transforms, Path, Editor } from 'slate';
import { defaultCalloutIcon } from '@atlas/tool/box/slate/createCalloutBlock';

export default function normalizeCalloutBlock(editor: Editor, node: CalloutBlock, path: Path) {
    if (!node.children?.length) {
        Transforms.removeNodes(editor, { at: path });
    } else if (node.children[0].type !== 'icon') {
        Transforms.insertNodes(
            editor,
            { type: 'icon', children: [{ text: '' }], icon: defaultCalloutIcon },
            { at: [...path, 0] },
        );
    } else if (node.children.length > 2) {
        const outBlocks = node.children.slice(2);
        const start = Editor.start(editor, [...path, 2]);
        const end = Editor.end(editor, path);
        Transforms.removeNodes(editor, { at: { anchor: start, focus: end } });
        Transforms.insertNodes(editor, outBlocks, { at: [path[0] + 1] });
    }
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('normalizeCalloutBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
